// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FROM = "Od";
export const STROLLER_DETAIL_count_PRODUCTS_IN_BAZAAR = ["%(count)s inzer\u00e1t v baz\u00e1ri", "%(count)s inzer\u00e1ty v baz\u00e1ri", "%(count)s inzer\u00e1tov v baz\u00e1ri"];
export const STROLLER_DETAIL_GO_TO_BAZAAR = "Do baz\u00e1ra";
export const STROLLER_DETAIL_WHERE_TO_BUY = "Kde k\u00fapim?";
export const STROLLER_DETAIL_WHERE_TO_BUY_NEW_MORE_SHOPS = "V\u0161etky obchody";
